export default function auth ({ next, to, role, store }) {
  let userRole
  if (store.state.login && store.state.login.role) {
    userRole = store.state.login.role
  } else {
    userRole = store.state.restaurant.role
  }
  if (userRole) {
    return role.includes(userRole)
      ? next()
      : next('/403')
  }
  return next()
}
